var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisiblityonIconSvgModel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9665 19.9998C25.9665 23.2998 23.2998 25.9665 19.9998 25.9665C16.6998 25.9665 14.0332 23.2998 14.0332 19.9998C14.0332 16.6998 16.6998 14.0332 19.9998 14.0332C23.2998 14.0332 25.9665 16.6998 25.9665 19.9998Z",
    stroke: "#B76E79",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 33.7833C25.883 33.7833 31.3663 30.3167 35.183 24.3167C36.683 21.9667 36.683 18.0167 35.183 15.6666C31.3663 9.66662 25.883 6.19995 19.9997 6.19995C14.1164 6.19995 8.63307 9.66662 4.81641 15.6666C3.31641 18.0167 3.31641 21.9667 4.81641 24.3167C8.63307 30.3167 14.1164 33.7833 19.9997 33.7833Z",
    stroke: "#B76E79",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisiblityonIconSvgModel);
export default __webpack_public_path__ + "static/media/visiblityonIconSVGModel.ba47250cc46470cb89065a6df3c80360.svg";
export { ForwardRef as ReactComponent };